<template>
  <div class="select-map-pos-container">
    <tianditu-map-picker
      ref="mapPicker"
      :value="mapData"
      mode="inline"
      :height="400"
      :zoom="16"
      @input="handleInput"
      @position-change="handlePositionChange"
    />
  </div>
</template>

<script>
export default {
  name: "SelectMapPos",
  props: {
    elementId: {
      type: String,
      default: "selectMap",
    },
    initData: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      mapData: {
        lat: null,
        lng: null,
        address: "",
      },
    };
  },
  methods: {
    initMap(data = {}) {
      this.mapData = this.normalizePosition(data);
      this.$nextTick(() => {
        if (this.$refs.mapPicker) {
          this.$refs.mapPicker.initMap();
        }
      });
    },
    normalizePosition(position = {}) {
      const lng = position.lng === "" || position.lng === null || position.lng === undefined
        ? null
        : Number(position.lng);
      const lat = position.lat === "" || position.lat === null || position.lat === undefined
        ? null
        : Number(position.lat);
      return {
        lng: Number.isFinite(lng) ? lng : null,
        lat: Number.isFinite(lat) ? lat : null,
        address: position.address || "",
      };
    },
    handleInput(position) {
      this.mapData = this.normalizePosition(position);
    },
    handlePositionChange(position) {
      const normalized = this.normalizePosition(position);
      this.mapData = normalized;
      if (normalized.lng === null || normalized.lat === null) {
        return;
      }
      this.$emit("position-change", normalized);
    },
    updatePosition(lat, lng) {
      this.mapData = this.normalizePosition({ lat, lng });
      this.$nextTick(() => {
        if (this.$refs.mapPicker) {
          this.$refs.mapPicker.syncMapFromCurrent();
        }
      });
    },
  },
};
</script>

<style scoped>
.select-map-pos-container {
  width: 100%;
}
</style>
